import { TemplateRef } from '@angular/core';

/**
 * Represents the configuration options for a table.
 */
export interface TableConfig {
    /**
     * Indicates whether the table rows should have a hover effect.
     */
    hover?: boolean;

    /**
     * Indicates whether the table should have striped rows.
     */
    striped?: boolean;

    /**
     * Indicates whether the table should have borders.
     */
    bordered?: boolean;

    /**
     * Indicates whether the table should be borderless.
     */
    borderless?: boolean;

    /**
     * Indicates whether the table caption should be at the top.
     */
    captionTop?: boolean;

    /**
     * Indicates whether the table should be compact.
     */
    compact?: boolean;

    /**
     * Specifies the color of the table.
     */
    // TODO: define table color
    // color?: TableColor;

    /**
     * Specifies the color of the table head.
     */
    // TODO: define head color
    // headColor?: TableHeadColor;

    /**
     * Indicates whether the table should be responsive.
     */
    // TODO: define table responsive
    // responsive?: TableResponsive;

    /**
     * Specifies the position of the sort arrow.
     */
    sortArrowPosition?: 'before' | 'after';

    /**
     * Indicates whether the table should have pagination.
     */
    pagination?: boolean;

    /**
     * Specifies the position of the pagination.
     */
    paginationAlignment?: 'start' | 'center' | 'end' | undefined;
    /**
     * A property to uniquely identify a record in data.
     */
    dataKey?: string;
    /**
     * A property to indicate the message of no data in the table.
     */
    emptyMessage?: EmptyMessage;

    /**
     * Indicates whether the table should have pagination.
     */
    typeTable?: TypeTable;

    /**
     * Defines whether sorting works on single column or on multiple columns.
     */
    sortMode: 'single' | 'multiple';
}

export const getDefaultTableConfig = (): TableConfig => ({
    hover: true,
    striped: true,
    bordered: false,
    borderless: false,
    captionTop: false,
    compact: false,
    // color: undefined,
    // headColor: undefined,
    // responsive: 'responsive',
    sortArrowPosition: 'after',
    pagination: true,
    paginationAlignment: 'center',
    dataKey: 'id',
    emptyMessage: {
        title: 'No data found',
        subtitle: 'There is no data to display.'
    },
    typeTable: {
        type: 'table'
    },
    sortMode: 'single'
});

export interface EmptyMessage {
    title: string;
    subtitle: string;
}

export interface TypeTable {
    type: 'table' | 'custom';
    template?: TemplateRef<unknown>;
}
